import { IconButton, Pause, Play, Slider, Spacer } from '@sparemin/blockhead';
import React, { useCallback } from 'react';
import { useIsInteractionDisabled } from '../../state';
import { block } from '../../utils';
import EditScenePreviewPlaybackTime from './EditScenePreviewPlaybackTime';

export type EditScenePreviewPlaybarProps = {
  duration: number;
  currentTime: number;
  isPlaying: boolean;
  onPlaybackChange: (isPlaying: boolean) => void;
  onSeek: (currentTime: number) => void;
  onSeekEnd?: (currentTime: number) => void;
};
const EditScenePreviewPlaybar: React.FC<EditScenePreviewPlaybarProps> = ({
  currentTime,
  duration,
  isPlaying,
  onPlaybackChange,
  onSeek,
  onSeekEnd,
}) => {
  const { isInteractionDisabled } = useIsInteractionDisabled();

  const handlePlayButtonClick = useCallback(() => {
    onPlaybackChange(!isPlaying);
  }, [isPlaying, onPlaybackChange]);

  return (
    <Spacer
      align="center"
      className={block('preview-playbar')}
      orientation="horizontal"
      space="medium"
    >
      <IconButton
        isDisabled={isInteractionDisabled}
        aria-label="toggle playback"
        className={block('preview-playbar-play-button')}
        onPress={handlePlayButtonClick}
      >
        {isPlaying ? <Pause /> : <Play />}
      </IconButton>
      <Slider
        className={block('preview-playbar-slider')}
        isDisabled={isInteractionDisabled}
        value={currentTime}
        maxValue={duration}
        minValue={0}
        step={0.01}
        onChange={onSeek}
        onChangeEnd={onSeekEnd}
        aria-label="video playback progress"
      />
      <EditScenePreviewPlaybackTime
        currentTime={currentTime}
        duration={duration}
      />
    </Spacer>
  );
};

export default EditScenePreviewPlaybar;
